<template>
  <!-- 多选题 -->
  <div class="CheckBox">
    <!-- 没有作答时候的div -->
    <div v-if="!data.answered">
      <!-- 问题 -->
      <div class="question clear">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
<!--          <span class="span" v-if="data.rule">（最多选{{data.rule.length}}个）</span>-->
          <span class="span" v-if="data.rule && data.itemList">最多选{{data.rule.length || data.itemList.length}}个</span>
<!--          <span class="span" v-if="data.rule">（最多选{{data.rule.length}}个）</span>-->
        </div>
      </div>

      <div class="answer">
        <!-- 答案循环 -->
        <div class="item" v-for="(i, index) in data.itemList" :key="i.itemNo+index">
          <!-- 左侧ABCD部分 -->
          <div class="item_left">
            <input type="checkbox" :disabled="disabledBol" v-model="i.bol" @change="objChange">
<!--            <el-checkbox v-model="i.bol"></el-checkbox>-->
            <div class="item_left_itemNo">{{i.itemNo}}. </div>
          </div>
          <!-- 答案文字部分 -->
          <div class="item_right">
            <div v-for="o in JSON.parse(i.itemDes?i.itemDes:'{}')" :key="JSON.stringify(o)">
              <span class="span">{{o.txt}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 作答后的div -->
    <div v-else>
      <!-- 问题 -->
      <div class="question clear">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
<!--          <span class="span" v-if="data.rule">（最多选{{data.rule.length}}个）</span>-->
          <span class="span" v-if="data.rule && data.itemList">（最多选{{data.rule.length || data.itemList.length}}个）</span>
        </div>
      </div>
      <!-- 选项区域 -->
      <div class="answer">
        <!-- 答案循环 -->
        <div class="item" v-for="(i, index) in data.itemList" :key="i.itemNo+index">
          <!-- 左侧ABCD部分 -->
          <div class="item_left">
            <input type="checkbox" :disabled="disabledBol" v-model="i.bol" @change="objChange">
<!--            <el-checkbox :disabled="disabledBol" v-model="i.bol" @change="objChange"></el-checkbox>-->
            <div class="item_left_itemNo">{{i.itemNo}}. </div>
          </div>
          <!-- 答案文字部分 -->
          <div class="item_right">
            <div v-for="o in JSON.parse(i.itemDes?i.itemDes:'{}')" :key="JSON.stringify(o)">
              <span class="span">{{o.txt}}</span>
            </div>
            <div class="progress" v-if="i.answerCount">
              <div class="progress_left">{{i.answerCount}}票</div>
              <div class="progress_box">
                <el-progress :percentage="i.answerPercentage.split('%')[0]*1" color="#2b6fff"></el-progress>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object,
    disabledBol: Boolean
  },
  computed: {
    // answerObj () {
    //   let arr = this.data.itemList || []
    //   let brr = []
    //   let obj
    //   for (let i in arr) {
    //     console.log(arr[i], 'answerObj')
    //     if (arr[i].bol) {
    //       brr.push(arr[i].itemId)
    //     }
    //   }
    //   // console.log(brr, 'brr')
    //   let length = this.data.rule ? this.data.rule.length : 999999
    //   if (brr.length > length) {
    //     obj = {
    //       msg: '超出选择答案数量'
    //     }
    //   } else if (brr.length === 0) {
    //     obj = {
    //       msg: '请选择答案后提交'
    //     }
    //   } else {
    //     obj = {
    //       questionId: this.data.questionId,
    //       item: brr.join('|')
    //     }
    //   }
    //   return obj
    // }
  },
  name: 'CheckBox',
  data () {
    return {
      answerObj: ''
    }
  },
  methods: {
    // 初始化
    init () {
      if (this.data.answered) {
        let arr = this.data.answered.split('|')
        let list = this.data.itemList
        for (let i in list) {
          if (arr.indexOf(list[i].itemId) > -1) {
            // this.$set(this.data.itemList[i], 'bol', true)
            list[i].bol = true
          }
        }
      }
    },
    objChange () {
      console.log(this.data, 'objChange')
      let arr = this.data.itemList || []
      let brr = []
      let obj
      for (let i in arr) {
        if (arr[i].bol) {
          brr.push(arr[i].itemId)
        }
      }
      // console.log(brr, 'brr')
      let length = this.data.rule ? this.data.rule.length : 999999
      if (brr.length > length) {
        obj = {
          msg: '超出选择答案数量'
        }
      } else if (brr.length === 0) {
        obj = {
          msg: '请选择答案后提交'
        }
      } else {
        obj = {
          questionId: this.data.questionId,
          item: brr.join('|')
        }
      }
      this.answerObj = obj
      return obj
    }
  },
  created () {
    this.init()
    this.objChange()
  }
}

</script>
<style lang="scss">
.CheckBox{
  .el-checkbox{
    margin-right: 0;
  }
}
</style>

<style lang="scss" scoped>
.CheckBox{
  margin-top: 24px;
  .question{
    margin-bottom: 16px;
    .title{
      color: #303133;
      font-size: 16px;
      .span{
        color: #909399;
        font-size: 12px;
      }
    }
  }
  .answer{
    .item{
      box-sizing: border-box;
      border-bottom: 1px solid #EBEEF5;
      display: flex;
      .item_left{
        display: flex;
        align-items: center;
        .item_left_itemNo{
          margin-left: 8px;
        }
      }
      .item_right{
        min-height: 70px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .progress{
          display: flex;
          margin-left: 8px;
          margin-top: 8px;
          font-size: 14px;
          line-height: 20px;
          align-items: center;
          color: #909399;
          .progress_box{
            margin-left: 8px;
            width: 206px;
          }
        }
      }
      .span{
        display: inline-block;
        line-height: 22px;
        margin-left: 8px;
        color: #303133;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/check-box.vue